import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=fdb6f490&scoped=true&"
import script from "./Feature.vue?vue&type=script&lang=js&"
export * from "./Feature.vue?vue&type=script&lang=js&"
import style0 from "./Feature.vue?vue&type=style&index=0&id=fdb6f490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb6f490",
  null
  
)

export default component.exports